/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import { apiUrl } from "../../../constants";
import OnChangeInputfield from "../../onChangeInputField/OnChangeInputField";
import Button from "../../button/Button";
import styles from "./UpdateForm.module.css";
import DropZone from "../dropZone/DropZone";
import FunctionalButton from "../../button/FunctionalButton";
import DeleteForm from "../deleteForm/DeleteForm";

const UpdateForm = ({
  itemToBeUpdated,
  idItemToBeUpdated,
  setItemToBeUpdated,
  route,
  title,
  toggleShowFullList,
  toggleDisplayContainer,
  toggleReloadAll,
}) => {
  const [success, toggleSuccess] = useState(false);
  const [dataReady, toggleDataReady] = useState(false);
  const [displayInsertForm, toggleDisplayInsertForm] = useState(true);
  const [error, toggleError] = useState(false);
  const [errorMessage, toggleErrorMessage] = useState(false);
  const [loading, toggleLoading] = useState(false);
  const [databaseMessage, setDatabaseMessage] = useState("");
  const [file, setFile] = useState(null); //will be set to File object after upload
  const [deleteForm, toggleDeleteForm] = useState(false);
  const [errorMessageDropZone, setErrorMessageDropZone] = useState("");

  function handleChange(e) {
    toggleError(false);
    setItemToBeUpdated(e.target.value);
  }

  function insert(e) {
    e.preventDefault();
    if (itemToBeUpdated.length > 0) {
      toggleDataReady(true);
    } else {
      toggleError(true);
    }
  }

  useEffect(() => {
    async function sendData() {
      toggleErrorMessage(false);
      toggleLoading(true);
      toggleSuccess(false);
      toggleDisplayInsertForm(false);
      const jwtToken = localStorage.getItem("token");
      if (title !== "publisher") {
        try {
          const result = await axios.put(
            `${apiUrl}/api/formsettings/${route}/${idItemToBeUpdated}`,
            {
              [title]: itemToBeUpdated.trim(),
            },
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          toggleDisplayInsertForm(false);
          toggleSuccess(true);
          setDatabaseMessage(result.data);
        } catch (e) {
          console.error(e);
          toggleErrorMessage(true);
          if (e.response !== undefined) {
            setDatabaseMessage(e.response.data.message);
          } else {
            setDatabaseMessage("Something went wrong. Please try again later.");
          }
        }
      } else if (title === "publisher" && file !== null) {
        try {
          const formData = new FormData();

          const newFileName =
            itemToBeUpdated.trim().split(" ").join("").toLocaleLowerCase() +
            "." +
            file.type.split("/")[1];
          formData.append("file", file, newFileName);
          formData.append("publisher", itemToBeUpdated.trim());

          // verstuur ons formData object en geef in de header aan dat het om een form-data type gaat
          const result = await axios.put(
            `${apiUrl}/api/formsettings/${route}/${idItemToBeUpdated}`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          toggleDisplayInsertForm(false);
          toggleSuccess(true);
          setDatabaseMessage(result.data);
        } catch (e) {
          console.error(e);
        }
      } else if (title === "publisher" && file === null) {
        try {
          const result = await axios.put(
            `${apiUrl}/api/formsettings/${route}/name/${idItemToBeUpdated}`,
            {
              [title]: itemToBeUpdated.trim(),
            },
            {
              headers: {
                Authorization: `Bearer ${jwtToken}`,
              },
            }
          );
          toggleDisplayInsertForm(false);
          toggleSuccess(true);
          setDatabaseMessage(result.data);
        } catch (e) {
          console.error(e);
          toggleErrorMessage(true);
          if (e.response !== undefined) {
            setDatabaseMessage(e.response.data.message);
          } else {
            setDatabaseMessage("Something went wrong. Please try again later.");
          }
        }
      }

      toggleLoading(false);
    }

    if (dataReady) {
      sendData();
    }
  }, [dataReady]);

  function displayInstruction() {
    if (route === "subheadings") {
      return (
        <p className={styles.message}>
          Please add subheading in plural if possible.
        </p>
      );
    }
  }

  function openDeleteWindow() {
    toggleDeleteForm(true);
    toggleDisplayInsertForm(false);
  }

  function returnToOverview() {
    toggleShowFullList(true);
    toggleDisplayContainer(false);
    toggleReloadAll(true);
  }

  return (
    <div className={styles["update-settings-form-container"]}>
      <div className={styles["form"]}>
        {displayInsertForm && (
          <form onSubmit={insert}>
            <h4>Update {title}</h4>
            <section>
              <OnChangeInputfield
                label=""
                name={title}
                type="text"
                id="setting-field"
                onChange={(e) => handleChange(e, { title })}
                value={itemToBeUpdated}
              />
              {displayInstruction()}
              <div className={styles["error-wrapper"]}>
                {error && (
                  <p className={styles.error}>
                    {title.charAt(0).toUpperCase() + title.slice(1)} is required
                  </p>
                )}
              </div>
            </section>

            {title === "publisher" && (
              <DropZone
                setFile={setFile}
                title={title}
                idItemToBeUpdated={idItemToBeUpdated}
                errorMessageDropZone={errorMessageDropZone}
                setErrorMessageDropZone={setErrorMessageDropZone}
              />
            )}

            <div className={styles["delete-button-container-update-settings"]}>
              <section
                className={styles["delete-button-wrapper-update-settings"]}
              >
                <FunctionalButton handleClick={openDeleteWindow} type="button">
                  Delete
                </FunctionalButton>
              </section>

              <section className={styles["button-wrapper-update-settings"]}>
                <Button type="submit">Submit</Button>
              </section>
            </div>
          </form>
        )}

        {deleteForm && (
          <DeleteForm
            idItemToBeUpdated={idItemToBeUpdated}
            route={route}
            title={title}
            itemToBeDeleted={itemToBeUpdated}
            toggleShowFullList={toggleShowFullList}
            toggleDisplayContainer={toggleDisplayContainer}
            toggleReloadAll={toggleReloadAll}
          />
        )}

        {loading && <p className={styles.loading}>Loading...</p>}

        {errorMessage && (
          <div className={styles["error-section"]}>
            <p className={styles.error}>{databaseMessage}</p>
          </div>
        )}

        {success && (
          <section>
            <p className="success-message">{databaseMessage}</p>

            <FunctionalButton type="button" handleClick={returnToOverview}>
              {`Return to ${title} list`}
            </FunctionalButton>
          </section>
        )}
      </div>
    </div>
  );
};

export default UpdateForm;
